import React from "react"
import Input from "../../Input"

const ForbiddenMsgNotify = ({ values, serverData }) => {
    return (
        <div className="mx-14 h-full font-sans">
            <h6 className="flex justify-center">کلمات ممنوعه</h6>
            <div className="">
                <Input
                    type="text"
                    label="ایدی ادمین برای اطلاعیه *"
                    name={`forbiddenMsgNotify-sgListToNotify`}
                    placeholder="RankID"
                    options={serverData?.sgList}
                    multi={true}
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.sgListToNotify}
                />
            </div>
            <div className="">
                <Input
                    type="text"
                    label="ایدی رنک ها برای چشم پوشی"
                    name={`forbiddenMsgNotify-ignoreSgList`}
                    placeholder="RankID"
                    options={serverData?.sgList}
                    multi={true}
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.ignoreSgList}
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    label="کلمات ممنوعه(با ,میتوانید کلمه هارو جدا کنید)"
                    name={`forbiddenMsgNotify-forbiddenWords`}
                    placeholder="مثال: salam,fohsh,khodafez"
                    autoComplete="off"
                    defaultValue={values?.forbiddenWords}
                    dir="ltr"
                />
            </div>

            <div className="mt-2">
                <Input
                    type="text"
                    label="فرمت پوک"
                    name={`forbiddenMsgNotify-pokeFormat`}
                    autoComplete="off"
                    defaultValue={values?.pokeFormat}
                    dir="ltr"
                />
            </div>

            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>
                    وقتی کاربری در هر چنلی که باشد کلماتی که به صورت دامنه باشند یا ایپی یا کلماتی که شما تعیین میکنید
                    را ارسال کند به ادمین اطلاع میده (فقط سرور های 1.5.6)
                </span>
                <br />
                <span>متغیرها:</span>
                <div dir="ltr">
                    <div>%user: نام کاربر</div>
                    <div>%text: پیام کامل</div>
                </div>
            </div>
        </div>
    )
}

export default ForbiddenMsgNotify
